"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _merchantElectricity = require("@/api/merchantElectricity");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantElectricityConfigDialog',
  data: function data() {
    return {
      visible: false,
      opening: false,
      loading: false,
      merchantAid: '',
      merchantName: '',
      list: []
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      if (!this.merchantAid) return '电费配置';
      return "\u7535\u8D39\u914D\u7F6E - [".concat(this.merchantAid, "] ").concat(this.merchantName || '');
    }
  },
  methods: {
    open: function open(row) {
      var _this = this;
      if (this.opening) return;
      this.merchantAid = row.merchant_aid != null ? row.merchant_aid : row.aid;
      this.merchantName = row.merchant_name || row.name || row.store_name || '';
      this.list = [];
      this.opening = true;
      var loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading'
      });
      (0, _merchantElectricity.getMerchantStoreList)(this.merchantAid).then(function (res) {
        var rows = res && res.list ? res.list : [];
        _this.list = rows.map(function (item) {
          return _this.mapRow(item);
        });
        _this.visible = true;
      }).catch(function () {
        // 错误提示由 request 拦截器统一弹出，此处不再重复
        _this.visible = false;
      }).finally(function () {
        _this.opening = false;
        loading.close();
      });
    },
    onClosed: function onClosed() {
      this.list = [];
    },
    mapRow: function mapRow(item) {
      var cfg = item.config || {};
      return _objectSpread(_objectSpread({}, item), {}, {
        _price: cfg.price_per_kwh != null ? String(cfg.price_per_kwh) : '',
        _settle: cfg.settle_enabled != null ? cfg.settle_enabled : 1,
        _withdraw: cfg.withdraw_enabled != null ? cfg.withdraw_enabled : 1,
        _saving: false
      });
    },
    loadList: function loadList() {
      var _this2 = this;
      this.loading = true;
      (0, _merchantElectricity.getMerchantStoreList)(this.merchantAid).then(function (res) {
        var rows = res && res.list ? res.list : [];
        _this2.list = rows.map(function (item) {
          return _this2.mapRow(item);
        });
      }).catch(function (err) {
        // 错误提示由 request 拦截器统一弹出
      }).finally(function () {
        _this2.loading = false;
      });
    },
    saveRow: function saveRow(row) {
      var _this3 = this;
      var price = parseFloat(row._price);
      if (!row._price || isNaN(price) || price <= 0) {
        this.$message.warning('电费单价必填且须大于 0');
        return;
      }
      row._saving = true;
      (0, _merchantElectricity.saveElectricityConfig)({
        store_id: row.store_id,
        price_per_kwh: price,
        settle_enabled: row._settle,
        withdraw_enabled: row._withdraw
      }).then(function () {
        _this3.$message.success('保存成功');
        row.has_config = 1;
      }).catch(function () {
        // 错误提示由 request 拦截器统一弹出
      }).finally(function () {
        row._saving = false;
      });
    }
  }
};